import React, { useEffect, useRef, useState } from "react";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { useCustomController } from "../../../Reusable/Form/useCustomController.js";
import { AutoCompleteContacts } from "./AutoCompleteContacts.js";
import { useUser } from "../../../../contexts/userContext/userContext.js";
import { EMAIL_VALIDATOR } from "helpers/validators.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import useMoveableLabel from "components/Pages/Home/UploadForms/useMoveableLabel.js";

const RecipientField = (props) => {
  const { getTextByKey } = useContent();
  const { isLoggedIn } = useUser();
  const { mobileCondition } = useMediaQueries();

  const { fieldControls, hasError } = useCustomController(props);
  const [value, setValue] = useState(fieldControls.value);

  // ----------------- start of section to submit recipient email within homepage, only in case externalProps is passed
  const setBody = props?.externalProps?.setBody;
  const submitValue = async () => {
    if (setBody) {
      if (EMAIL_VALIDATOR.test(value)) {
        setBody((prev) => ({
          ...prev,
          SendToEmail: value,
        }));
      }
    }
  };
  // ----------------- end of section

  useEffect(() => {
    fieldControls.onChange(value);
    submitValue();
  }, [value]);

  useEffect(() => {
    if (fieldControls.value !== value) setValue(fieldControls.value);
  }, [fieldControls.value]);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleContactClick = (email) => {
    setValue(email);
  };

  const focusRef = useRef();

  useEffect(() => {
    if (props.focus && !mobileCondition) {
      focusRef.current.focus();
    }
  }, []);

  const { labelClassName } = useMoveableLabel({
    label: props.item.label,
    value,
  });

  return (
    <label className={`border-bottom-only${hasError ? " invalid-input" : ""}`}>
      <div className={labelClassName || "input-label"}>
        {getTextByKey("send-to-title")}
      </div>
      <input
        className="input-field "
        type="email"
        autoComplete={"ShareToEmailRecipientTitle"}
        value={value}
        onChange={handleChange}
        ref={focusRef}
        onBlur={submitValue}
      />
      {isLoggedIn() ? (
        <AutoCompleteContacts
          value={value || ""}
          handleClick={handleContactClick}
        />
      ) : null}
    </label>
  );
};

export default RecipientField;
